// Import both actions
import {
  _updateFilterData,
  _setFilterData,
  _setBackToInitialFilterData,
  _setSearchPending,
  _hideFilters,
  _setInitialFilterConf,
  _setFiltersBarExpanded,
} from './reducer';


// True while a debounced search has been typed but not yet applied to the store.
// Pages OR this into their table `loading` so the table reacts the instant the
// user starts typing, not only once the (debounced) request fires.
export const setSearchPending = (pending) => async (dispatch) => {
  dispatch(_setSearchPending(pending));
};



export const updateFilterData = updates => async (dispatch) => {
  console.log('updateFilterData', updates)
  // Reset pagination when a non-page filter changes, so the user
  // doesn't land on a now-out-of-range page (which yields a 404).
  const keys = Object.keys(updates);
  const isPageOnly = keys.length === 1 && keys[0] === 'page';
  const payload = (!isPageOnly && !('page' in updates))
    ? { ...updates, page: 1 }
    : updates;
  dispatch(_updateFilterData(payload));
};

export const setFilterData = (newFilterData) => async (dispatch) => {
  console.log('setFilterData', newFilterData)
  dispatch(_setFilterData(newFilterData));
};


// Reset filters to the page's initial defaults (e.g. the intents list defines a
// default period / date_range). Used by every "clear filters" control so the
// behaviour is identical wherever it's triggered.
export const clearFilterData = () => async (dispatch) => {
  console.log('clearFilterData')
  dispatch(_setBackToInitialFilterData());
};


export const hideFilters = hiddenList => async (dispatch) => {
  dispatch(_hideFilters(hiddenList));
};

export const setInitialFilterConf = data => async (dispatch) => {
  console.log('setInitialFilterConf', data)
  dispatch(_setInitialFilterConf(data));
};
export const setFiltersBarExpanded = isExpanded => async (dispatch) => {
  console.log('setFiltersBarExpanded', isExpanded)
  dispatch(_setFiltersBarExpanded(isExpanded));
};
